import api from '@/libs/axios'
import { addOrUpdateInList, cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import store from '../index'
import useAppConfig from '../../utils/useAppConfig'

export default {
  getOffers ({ commit, state }, payload) {
    store.commit('app/ADD_LOADER')

    const { recursiveCallIterativeLimit, recursiveCall } = useAppConfig()
    let limit = payload.limit
    let offset = 0

    return new Promise((resolve, reject) => {
      let url = '/offers'
      let params = new URLSearchParams({ limit: limit, offset: offset })

      api.get(url + '?' + params)
        .then(response => {
          // console.log(JSON.stringify(response.data))
          commit('SET_OFFERS', response.data)

          if (response.data.length == limit) {
            offset += limit
            limit = recursiveCallIterativeLimit
            recursiveCall(url, 'offer', limit, offset, state.offers, commit, 1).then(() => {
              store.commit('app/REMOVE_LOADER')
              resolve(true)
            })
          } else {
            store.commit('app/REMOVE_LOADER')
            resolve(true)
          }
        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  getOffer ({ commit, state }, offerId) {
    store.commit('app/ADD_LOADER')

    return new Promise((resolve, reject) => {
      api.get('/offers/' + offerId)
        .then(response => {
          addOrUpdateInList(response.data, state.offers, 'offer', commit)

          store.commit('app/REMOVE_LOADER')
          resolve(response.data)

        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addOffer ({ commit, state }, offer) {
    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/offers', clonedEntityToSend)
            .then(response => {
              commit('ADD_OFFER', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The offer has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateOffer ({ commit, state }, offer) {
    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.put('/offers/' + offer.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_OFFER', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The offer has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeOffer ({ commit }, offer) {
    return new Promise((resolve, reject) => {
      api.delete('/offers/' + offer.id)
        .then(response => {
          commit('REMOVE_OFFER', offer)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The offer has been ', { crud: i18n.t('removedE') }),
              variant: 'success'
            },
          })

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },
  // async validateOffer ({ commit, state }, offer) {
  //   return new Promise((resolve, reject) => {
  //     api.put('/offers/' + offer.id + '/validate')
  //       .then(response => {
  //         commit('UPDATE_OFFER', response.data)
  //         Vue.$toast({
  //           component: ToastificationContent,
  //           props: {
  //             title: capitalize(i18n.t('success')),
  //             icon: 'check',
  //             text: i18n.t('The offer has been ', { crud: i18n.t('edited') }),
  //             variant: 'success'
  //           },
  //         })
  //
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         console.log('Error', error)
  //         reject(error)
  //       })
  //   })
  // },
  async transformProductsToOutgoingInvoice ({ commit, state }, payload) {
    let offer = payload.offer
    offer.toInvoice = ''
    payload.selectedProducts.forEach(sp => {
      let quantity = (typeof sp._selectedQuantity !== 'undefined')?sp._selectedQuantity:sp.quantity

      if (offer.toInvoice == '') {
        offer.toInvoice = '{"productId":' + sp.id + ',"quantity":' + quantity + '}'
      } else {
        offer.toInvoice += '@{"productId":' + sp.id + ',"quantity":' + quantity + '}'
      }
    })

    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {
         return new Promise((resolve, reject) => {
          api.put('/offers/' + offer.id + '/transformToOutgoingInvoice', clonedEntityToSend)
            .then(response => {
              payload.selectedProducts.forEach(p => p.outgoingInvoice = response.data.outgoingInvoice)

              offer._linkedOutgoingInvoices.push(response.data.outgoingInvoice)
              response.data.outgoingInvoice.products.forEach(op => {
                let ofp = offer.products.find(p => p.id == op.parent.id)
                ofp._remaining = ofp._remaining-op.quantity
              })

              // commit('UPDATE_OFFER', response.data)
              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The outgoingInvoice has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  // printOfferQuote ({ commit }, offer) {
  //   return new Promise((resolve, reject) => {
  //     api.get('/offers/' + offer.id + '/quotePdf')
  //       .then(response => {
  //         let displayQuoteNumber = offer.billNumber + '-'
  //
  //         if (offer.version < 10) {
  //           displayQuoteNumber += ('00' + offer.version.toString())
  //         } else {
  //           if (offer.version < 100) {
  //             displayQuoteNumber += ('0' + offer.version.toString())
  //           } else {
  //             displayQuoteNumber += offer.version.toString()
  //           }
  //         }
  //
  //         let byteCharacters = atob(response.data)
  //         let byteNumbers = new Array(byteCharacters.length)
  //         for (var i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i)
  //         }
  //         let byteArray = new Uint8Array(byteNumbers)
  //         let blob = new Blob([byteArray], {
  //           type: 'application/pdf'
  //         })
  //
  //         let link = document.createElement('a')
  //         link.href = window.URL.createObjectURL(blob)
  //         link.download = capitalize(i18n.tc('quote')) + ' - ' + displayQuoteNumber + '.pdf'
  //         link.click()
  //         resolve(response)
  //       })
  //       .catch(err => {
  //         console.log('Error', err)
  //         reject(err)
  //       })
  //   })
  // },

}